import React from 'react';
import { CiCircleChevLeft } from "react-icons/ci";
import { IoClose } from "react-icons/io5";
import MyButton from '../../common/Button/MyButton';
import '../../../assets/styles/customer/components/MySidebar.css';

const MySidebar = ({ isOpen, onClose }) => {
  return (
    <>
      {/* Sidebar */}
      <div className={`mobile-sidebar ${isOpen ? 'active' : ''}`}>
        <div className="sidebar-header">
          <h3 className="sidebar-title">Menu</h3>
          <button className="sidebar-close-btn" onClick={onClose}>
            <IoClose size={24} />
          </button>
        </div>

        <div className="sidebar-content">
          {/* User Section */}
          <div className="sidebar-user-section">
            <CiCircleChevLeft size={50} color="var(--secondary-color)" />
            <p className="sidebar-user-text">Welcome!</p>
          </div>

          {/* Menu Items */}
          <div className="sidebar-menu">
            <a href="#pricing" className="sidebar-link" onClick={onClose}>
              Pricing
            </a>
            <a href="#about" className="sidebar-link" onClick={onClose}>
              About
            </a>
            <a href="#contact" className="sidebar-link" onClick={onClose}>
              Contact
            </a>
          </div>

          {/* Actions */}
          <div className="sidebar-actions">
            <button className="sidebar-login-btn" onClick={onClose}>
              Login
            </button>
            <MyButton variant="primary" className="w-100">
              Become a Distributor
            </MyButton>
          </div>
        </div>
      </div>

      {/* Overlay */}
      {isOpen && <div className="sidebar-overlay" onClick={onClose}></div>}
    </>
  );
};

export default MySidebar;

/* import React from "react";
import { Offcanvas, Nav, Button } from "react-bootstrap";
import "./MySidebar.css";
import { Link } from "react-router-dom";

const MySidebar = ({ show, onHide }) => {
  return (
    <Offcanvas show={show} onHide={onHide} placement="start" className="sidebar">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="fw-bold text-danger">Milky Way</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Nav className="flex-column">
          <Nav.Link as={Link} to="/" onClick={onHide}>Home</Nav.Link>
          <Nav.Link as={Link} to="/pricing" onClick={onHide}>Pricing</Nav.Link>
          <Nav.Link as={Link} to="/about" onClick={onHide}>About</Nav.Link>
          <Nav.Link as={Link} to="/contact" onClick={onHide}>Contact</Nav.Link>
        </Nav>
        <Button variant="primary" className="w-100 mt-3" onClick={onHide}>
          Become a distributor
        </Button>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default MySidebar; */


/* import React from "react";
import PropTypes from "prop-types";
import { Nav, Offcanvas } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const MySidebar = ({ show, onHide }) => {
  const links = [
    { to: "/", label: "Dashboard", exact: true },
    { to: "/members", label: "Members" },
    { to: "/attendance", label: "Attendance" },
    { to: "/payments", label: "Payments" },
  ];
  return (
    <>
      <aside className="sidebar d-none d-md-flex flex-column p-3 bg-white border-end">
        <h5 className="mb-3">Menu</h5>
        <Nav className="flex-column">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.exact}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : "text-muted"}`
              }
              style={{ padding: ".5rem 0" }}
            >
              {l.label}
            </NavLink>
          ))}
        </Nav>
      </aside>
      <Offcanvas show={show} onHide={onHide} responsive="md">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.exact}
                onClick={onHide}
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : "text-muted"}`
                }
                style={{ padding: ".5rem 0" }}
              >
                {l.label}
              </NavLink>
            ))}
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

MySidebar.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default MySidebar;
 */